import React, { useEffect, useState } from "react";
import { FaFacebookF, FaTelegramPlane, FaTwitter, FaDownload } from "react-icons/fa";
import "./Footer.css";
import { ApiPaths } from "../../Config";
import axios from "axios";
import { Data } from "../../Common/Data";
import { BasicInfo } from "../../Config/BasicInfo";

const Footer = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [showUserAgreement, setShowUserAgreement] = useState(false);
  const [showTermsConditions, setShowTermsConditions] = useState(false);

  useEffect(() => {
    FetchData();
  }, []);

  function FetchData(checkload) {
    let userId = localStorage.getItem("userId");
    axios({
      method: "post",
      url: ApiPaths.dashboard,
      data: {
        u_id: userId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(function (response) {
        // Data.isDebug && console.log("Footer", response);
        setDashboardData(response?.data);
      })
      .catch(function (response) {
        // Data.isDebug && console.log(response);
      });
  }

  const handleWhitepaperDownload = () => {
    const link = document.createElement('a');
    link.href = '/Pdf/dcent_whitepaper.pdf';
    link.download = 'dcent_whitepaper.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const UserAgreementContent = () => (
    <div className="popup-content">
      <button className="popup-close" onClick={() => setShowUserAgreement(false)}>×</button>
      <div className="popup-header">
        <h2>📄 D'CENT Capital – User Agreement</h2>

      </div>
      <div className="popup-body">
        <div className="agreement-section">
          <h3>🔐 Welcome to D'cent Capital</h3>
          <p>Before you begin, please read and agree to our User Agreement.</p>
        </div>

        <div className="agreement-section">
          <h3>1. Platform Overview</h3>
          <p>D'CENT Capital is a cutting-edge professional crypto trading platform designed to empower modern traders with advanced analytics, automated strategies, and real-time insights...</p>
        </div>

        <div className="agreement-section">
          <h3>2. Key Features for Users</h3>
          <ul>
            <li><strong>Advanced Analytics Tools:</strong> Deep market insights, price trends, and AI-driven forecasts.</li>
            <li><strong>Real-time Risk Alerts & Signals:</strong> Stay updated on market movements.</li>
            <li><strong>Risk Management Features:</strong> Stop-loss, take-profit, and portfolio controls.</li>
            <li><strong>Data-Driven Decisions:</strong> Dashboards, sentiment analysis, heatmaps, and more.</li>
            <li><strong>AI & Machine Learning:</strong> Smart algorithms to refine strategies.</li>
            <li><strong>Automation & Bots:</strong> Support for bot frameworks and custom scripting.</li>
            <li><strong>Security First:</strong> Military-grade encryption, 2FA, and cold wallet integrations.</li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>3. Who Can Use D'CENT Capital</h3>
          <ul>
            <li>Day Traders & Scalpers</li>
            <li>Swing Traders</li>
            <li>Algorithmic & Bot Traders</li>
            <li>Crypto Hedge Funds & Institutions</li>
            <li>Newcomers Seeking Smart Insights</li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>4. User Income Streams</h3>
          <ul>
            <li><strong>CapitalFlow:</strong> Auto ROI increases every 15 days (no referral needed).</li>
            <li><strong>TURBO:</strong> Instant ROI boosts from direct referrals.</li>
            <li><strong>INVITEPAY:</strong> 5% instant referral reward.</li>
            <li><strong>LEVELFLOW:</strong> Team-based level earnings structure.</li>
            <li><strong>LEGACY FLOW™:</strong> Passive daily rewards based on rank and team volume.</li>
          </ul>
          <p><strong>Legacy Qualification Rule:</strong> 40% of business from Prime Line and 60% from Support Lines.</p>
          <p><strong>Legacy Release:</strong> Rewards released after 30-day hold on the 1st of each month.</p>
        </div>

        <div className="agreement-section">
          <h3>5. User Responsibilities</h3>
          <ul>
            <li>Comply with all applicable laws and platform terms.</li>
            <li>Invest responsibly and understand risks.</li>
            <li>Acknowledge that income is performance-based, not fixed.</li>
          </ul>
        </div>
      </div>
    </div>
  );

  const TermsConditionsContent = () => (
    <div className="popup-content">
      <button
        className="popup-close"
        onClick={() => setShowTermsConditions(false)}
      >
        ×
      </button>
      <div className="popup-header">
        <h2>📜 D'CENT Capital – Terms & Conditions</h2>
      </div>
      <div className="popup-body">
        <div className="agreement-section">
          <h3>1. Introduction to D'CENT Capital</h3>
          <p>
            D'CENT Capital is a cutting-edge professional crypto trading
            platform designed to empower modern traders with advanced analytics,
            automated strategies, and real-time insights. D'CENT Capital aims to
            empower users with tools for smart crypto trading.
          </p>
        </div>

        <div className="agreement-section">
          <h3>2. Eligibility and Compliance</h3>
          <p>
            Users must be of legal age and must comply with their local laws and
            financial regulations to participate.
          </p>
        </div>

        <div className="agreement-section">
          <h3>3. Investment and Risk Disclosure</h3>
          <ul>
            <li>Investments on D'CENT Capital are subject to market risks.</li>
            <li>
              Users are strongly encouraged to invest responsibly and to consult
              with a professional financial advisor if needed.
            </li>
            <li>
              All incomes are based on live business performance only, and no
              future or fixed returns are promised.
            </li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>4. D'CENT Token (DCOR) and Allocation</h3>
          <p>
            <strong>Token Name:</strong> DCENT ORIGIN
          </p>
          <p>
            <strong>Token Symbol:</strong> DCOR
          </p>
          <p>
            <strong>Blockchain:</strong> Binance Smart Chain (BEP20)
          </p>
          <p>
            <strong>Total Supply:</strong> 50,000,000 DCOR (50 Million)
          </p>

          <h4>Token Allocation Breakdown:</h4>
          <ul>
            <li>
              <strong>Rewards & Airdrops:</strong> 40% (20,000,000 tokens)
            </li>
            <li>
              <strong>Development & Listing Reserve:</strong> 10% (5,000,000
              tokens)
            </li>
            <li>
              <strong>Core Team:</strong> 3% (1,500,000 tokens)
            </li>
            <li>
              <strong>Legal & Compliance:</strong> 2% (1,000,000 tokens)
            </li>
            <li>
              <strong>Strategic Alliance:</strong> 5% (2,500,000 tokens)
            </li>
            <li>
              <strong>Locked (3 Years - 1095 Days):</strong> 10% (5,000,000
              tokens)
            </li>
            <li>
              <strong>Locked (5 Years - 1825 Days):</strong> 10% (5,000,000
              tokens)
            </li>
            <li>
              <strong>Locked (10 Years - 3650 Days):</strong> 20% (10,000,000
              tokens)
            </li>
          </ul>
          <p>
            <strong>Lock Mechanism Notes:</strong> Locked tokens will be held in
            a time-lock smart contract. The mechanism is transparent & auditable
            on BSCScan.
          </p>
          <p>
            Users will receive free D'Cent Tokens with every investment as per
            the live token rate.
          </p>
        </div>

        <div className="agreement-section">
          <h3>5. Investment Policies</h3>
          <p>
            <strong>Minimum and Maximum Investment:</strong> Users can start
            with a minimum investment of $20 and go up to $50,000.
          </p>

          <h4>Principal Withdrawal Policy:</h4>
          <ul>
            <li>Principal can be withdrawn anytime.</li>
            <li>
              20% of the principal amount will be held for 90 days from the date
              of withdrawal request.
            </li>
            <li>
              If you earn 80% of your capital amount, you can't withdraw your
              principal amount.
            </li>
            <li>
              The withdrawable amount is calculated as Eligible Principal –
              Total ROI Earned.
            </li>
            <li>
              Example: For a $1000 package, if the eligible principal is $800
              and total income earned is $400, the principal withdrawable is
              $400 ($800 - $400).
            </li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>6. Income Capping Rule</h3>
          <ul>
            <li>
              Users can earn a maximum of 3X (300%) of their package value from
              all income types combined.
            </li>
            <li>
              After reaching this cap, no further income will be generated
              unless you reinvest or upgrade your package.
            </li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>7. Charges and Payouts</h3>
          <ul>
            <li>
              <strong>Withdrawal Charge:</strong> You will get a D'Cent token of
              15% of your withdrawal amount at the live rate.
            </li>
            <li>
              <strong>Transfer (Earning to Wallet) Charge:</strong> You will get
              a D'Cent token of 5% of your transfer amount at the live rate.
            </li>
            <li>
              Users can withdraw up to 10% of their total allocated tokens per
              month.
            </li>
          </ul>
        </div>

        <div className="agreement-section">
          <h3>8. Anti-Fraud Policy</h3>
          <p>
            Any attempt at fraudulent activity, system abuse, or
            misrepresentation will result in account suspension or termination.
          </p>
        </div>

        <div className="agreement-section">
          <h3>9. Policy Updates</h3>
          <p>
            D'Cent Capital reserves the right to modify, update, or cancel any
            of its policies, plans, or terms at any time without prior notice.
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <section className="footer">
        <p>2026 {BasicInfo.projectName} : All Right Reserved</p>
        {/* <div className="footer-links">
          <button className="footer-link" onClick={() => setShowUserAgreement(true)}>
            User Agreement
          </button>
          <span className="footer-separator">|</span>
          <button className="footer-link" onClick={() => setShowTermsConditions(true)}>
            Terms & Conditions
          </button>
          <span className="footer-separator">|</span>
          <button className="footer-link download-btn" onClick={handleWhitepaperDownload}>
            <FaDownload /> Whitepaper
          </button>
        </div> */}
        <div className="socialIcons">
          {dashboardData?.telegram_link?.length == 0 && (
            <a href={dashboardData?.telegram_link} target="_blank">
              <i>
                <FaTelegramPlane />
              </i>{" "}
            </a>
          )}
          {dashboardData?.twitter_link?.length == 0 && (
            <a href={dashboardData?.twitter_link} target="_blank">
              <i>
                <FaTwitter />
              </i>{" "}
            </a>
          )}
          {dashboardData?.facebook_link?.length == 0 && (
            <a href={dashboardData?.facebook_link} target="_blank">
              <i>
                <FaFacebookF />
              </i>{" "}
            </a>
          )}
        </div>
      </section>

      {/* User Agreement Popup */}
      {showUserAgreement && (
        <div className="popup-overlay" onClick={() => setShowUserAgreement(false)}>
          <div className="popup-container" onClick={(e) => e.stopPropagation()}>
            <UserAgreementContent />
          </div>
        </div>
      )}

      {/* Terms & Conditions Popup */}
      {showTermsConditions && (
        <div className="popup-overlay" onClick={() => setShowTermsConditions(false)}>
          <div className="popup-container" onClick={(e) => e.stopPropagation()}>
            <TermsConditionsContent />
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
